/** Whether removing a record's association with a tag should also delete tags left unused. */
export var FlowRecordTagCleanupMode;
(function (FlowRecordTagCleanupMode) {
    FlowRecordTagCleanupMode["PreserveTags"] = "PreserveTags";
    FlowRecordTagCleanupMode["RemoveTags"] = "RemoveTags";
})(FlowRecordTagCleanupMode || (FlowRecordTagCleanupMode = {}));
/** The shape a record's aggregated tags take on the way out. */
export var FlowAggregatedTagMode;
(function (FlowAggregatedTagMode) {
    FlowAggregatedTagMode["NameList"] = "nameList";
    FlowAggregatedTagMode["TagObjectList"] = "tagObjectList";
})(FlowAggregatedTagMode || (FlowAggregatedTagMode = {}));
/** Whether a tag is stored against the record or resolved from a tag's parent. */
export var FlowRecordTagVariant;
(function (FlowRecordTagVariant) {
    FlowRecordTagVariant["Direct"] = "Direct";
    FlowRecordTagVariant["Inferred"] = "Inferred";
})(FlowRecordTagVariant || (FlowRecordTagVariant = {}));
//# sourceMappingURL=recordTag.js.map